import store from "@plugins/store";
import appConfigs from "@configs/app";
import { cookieManager } from "@utils/cookie.manager";
import { isEmpty } from "@utils/var.check";
import { isValidRedirectUrlDomain } from "./router.redirect";
import { ROUTE_ACCESS } from "./router.const";

export async function isLoggedIn() {
  try {
    await store.dispatch("auth/authCheck");

    await store.dispatch("app/fetchCurrentAcademicYear");
  } catch (e) {
    console.error(e);
    return false;
  }
  return store.getters["auth/isLogged"];
}

export function isValidUrlDomain(url) {
  return (!isEmpty(url) && isAppVleDomain(url)) || isValidRedirectUrlDomain(url);
}

function isAppVleDomain(url) {
  return url.startsWith(appConfigs.vleDomain);
}

export function saveRequestBeforeLogin(from) {
  const publicRoute = from.meta.access === ROUTE_ACCESS.PUBLIC;
  if (!publicRoute) {
    cookieManager.createCookie("SAVED_REQUEST_URL", window.location, null);
  }
}

export function saveRequest() {
  const savedRequestUrl = cookieManager.getCookie("SAVED_REQUEST_URL");
  if (!savedRequestUrl) {
    cookieManager.createCookie("SAVED_REQUEST_URL", window.location, null);
  }
}
